import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PermissionDeniedComponent } from './permission-denied.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    TranslateModule.forChild(),
    CommonModule
  ],
  declarations: [
    PermissionDeniedComponent
  ],
  exports: [
    PermissionDeniedComponent
  ]
})
export class PermissionDeniedModule {}
